import { redirect } from 'react-router-dom';

import { routes as authRoutes } from '@modules/auth/routes';

import type { RouteObject } from 'react-router-dom';

export type PageMeta = {
  title: string;
};

export type AppRouteObject = RouteObject & {
  pageMeta?: PageMeta;
  children?: AppRouteObject[];
};

export const routes: AppRouteObject[] = [
  {
    index: true,
    loader: () => {
      const ENV = process.env.VITE_ENVIRONMENT ?? 'local';
      const RECOVERY_COLLECTIVE_URL = process.env.VITE_RECOVERY_COLLECTIVE_URL;

      const redirectToRecoveryCollective =
        ['dev', 'demo', 'prod'].includes(ENV) &&
        Boolean(RECOVERY_COLLECTIVE_URL);

      window.location.href = redirectToRecoveryCollective
        ? `${RECOVERY_COLLECTIVE_URL}/login`
        : '/auth/login';

      return null;
    },
  },
  ...authRoutes,
  {
    path: '*',
    loader: () => redirect('/'),
  },
];
